export class TaskSourceSystem {
    constructor(
        public sourceSystem:  string,
        public validResponse: boolean,
        public responseMessage: string,
        public tasks: Task[]
    ){}
}

export class Task {
    constructor(
        public type: string,
        public dueDate: string,
        public dueDateShort: string,
        public isToday: boolean,
        public isPast: boolean,
        public description: string,
        public url: string
    ){}
}